import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
import React from "react";

function BlogGridSlider() {
    const settings = {
        infinite: true,
        dots: false,
        arrows:true,
        slidesToShow: 3,
        slidesToScroll: 1,
        lazyLoad: true,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 2,
                infinite: true,
                dots: true
              }
            },
            {
                breakpoint: 992,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  dots: true
                }
              },
            {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false
              }
            }
          ]
    };
  return (
    <>
     <section className="section-padding blog-bg">
        <div className="testimonial-overlayer"></div>
        <div className="container-fluid">
            <div className="section-header">
                <h3 className="title">BLOG GRID</h3>
                <p className="text">Lorem ipsum dolor sit amet, consectetur.</p>
            </div>
            <Slider {...settings}>
                <article className="slide-item col-12 post">
                    <div className="post_image">
                        <Link to="/blog-details">
                            <img src="/tm/react/toolways/assets/images/blog/kosu.jpg" className="image-fit" alt="img"/>
                        </Link>
                        <Link to="/blog-details" className="post_date">
                            18 Oct
                        </Link>
                    </div>
                    <div className="post_caption">
                        <ul className="post_meta">
                            <li>
                                <Link to="blog-grid.html">
                                    <i className="fa fa-user"></i>
                                    Admin
                                </Link>
                            </li>
                            <li>
                                <Link to="blog-grid.html">
                                    <i className="fa fa-tag"></i>
                                    tools Instruction
                                </Link>
                            </li>
                        </ul>
                        <h2 className="post_title">
                            <Link to="/blog-details" style={{ color: 'var(--thm-white)' }}>Most Advanced quality machine</Link>
                        </h2>
                    </div>
                </article>
                <article className="slide-item col-12 post">
                    <div className="post_image">
                        <Link to="/blog-details">
                            <img src="/tm/react/toolways/assets/images/blog/allan.jpg" className="image-fit" alt="img"/>
                        </Link>
                        <Link to="/blog-details" className="post_date">
                            18 Oct
                        </Link>
                    </div>
                    <div className="post_caption">
                        <ul className="post_meta">
                            <li>
                                <Link to="blog-grid.html">
                                    <i className="fa fa-user"></i>
                                    Admin
                                </Link>
                            </li>
                            <li>
                                <Link to="blog-grid.html">
                                    <i className="fa fa-tag"></i>
                                    Tools Instruction
                                </Link>
                            </li>
                        </ul>
                        <h2 className="post_title">
                            <Link to="/blog-details" style={{ color: 'var(--thm-white)' }}>Best corded drill power tools</Link>
                        </h2>
                    </div>
                </article>
                <article className="slide-item col-12 post">
                    <div className="post_image">
                        <Link to="/blog-details">
                            <img src="/tm/react/toolways/assets/images/blog/ono.jpg" className="image-fit" alt="img"/>
                        </Link>
                        <Link to="/blog-details" className="post_date">
                            18 Oct
                        </Link>
                    </div>
                    <div className="post_caption">
                        <ul className="post_meta">
                            <li>
                                <Link to="blog-grid.html">
                                    <i className="fa fa-user"></i>
                                    Admin
                                </Link>
                            </li>
                            <li>
                                <Link to="blog-grid.html">
                                    <i className="fa fa-tag"></i>
                                    Tools Instruction
                                </Link>
                            </li>
                        </ul>
                        <h2 className="post_title">
                            <Link to="/blog-details" style={{ color: 'var(--thm-white)' }} >power full motor of best perfomance</Link>
                        </h2>
                    </div>
                </article>
                <article className="slide-item col-12 post">
                    <div className="post_image">
                        <Link to="/blog-details">
                            <img src="/tm/react/toolways/assets/images/blog/1.jpg" className="image-fit" alt="img"/>
                        </Link>
                        <Link to="/blog-details" className="post_date">
                            18 Oct
                        </Link>
                    </div>
                    <div className="post_caption">
                        <ul className="post_meta">
                            <li>
                                <Link to="blog-grid.html">
                                    <i className="fa fa-user"></i>
                                    Admin
                                </Link>
                            </li>
                            <li>
                                <Link to="blog-grid.html">
                                    <i className="fa fa-tag"></i>
                                    tools Instruction
                                </Link>
                            </li>
                        </ul>
                        <h2 className="post_title">
                            <Link to="/blog-details" style={{ color: 'var(--thm-white)' }}>Super Power Machine</Link>
                        </h2>
                    </div>
                </article>
            </Slider>
        </div>
    </section>
    </>
  )
}

export default BlogGridSlider